export default __webpack_public_path__ + "static/media/only-games-bg.a415a84d.png";